import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";

import 'common/css/master.css';
import Loader from 'common/components/Loader';


import AssessmentTabs from "./assessmentTabs";
import ParentDtls from "./parentDtls";
import Interests from "./interests";
import Friends from "./friends";
import Resources from "./resources";
import Assessment from "./assessment";


const HpcParentAssessment = () => {

    const params = new URLSearchParams(window.location.search);

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [tabId, setTabId] = useState('dtls');
    const [staffId, setStaffId] = useState(0);
    const [studentId, setStudentId] = useState(0);
    const [schoolId, setSchoolId] = useState(0);
    const [acdYrId, setAcdYrId] = useState(0);
    const [clsId, setClsId] = useState(0);
    const mapTabs = {
        dtls: "General - Info",
        fav: "Interests/Favourites",
        frnd: "Friends",
        resc: "Resources",
        asses: "Assessment",
    };

    useEffect(() => {
        // console.log("HpcParentAssessment called");
        // console.log("tchId", params.get("tchId"));
        // console.log("acdYrId", params.get("acdYrId"));
        // console.log("schId", params.get("schId"));
        // console.log("stdId", params.get("stdId"));

        let pstaffId = params.get("tchId");
        let pacdYrId = params.get("acdYrId");
        let pschoolId = params.get("schId");
        let pstudentId = params.get("stdId");
        let pclsId = params.get("clsId");

        setStaffId(pstaffId);
        setAcdYrId(pacdYrId);
        setSchoolId(pschoolId);
        setStudentId(pstudentId);
        setClsId(pclsId);
    }, []);

    return (
        <div>
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-sm-12 col-xs-12 " style={{ padding: "5px" }}>
                <div className="col-md-8 col-sm-10 col-xs-12 col-centered padding-remove">
                    <AssessmentTabs mapTabs={mapTabs} tabId={tabId} setTabId={setTabId} />
                </div>
                <div className="col-md-8 col-sm-10 col-xs-12 col-centered padding-remove">
                    {(() => {
                        switch (tabId) {
                            case 'dtls':
                                return (
                                    <ParentDtls
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                            case 'fav':
                                return (
                                    <Interests
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                            case 'frnd':
                                return (
                                    <Friends
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                            case 'resc':
                                return (
                                    <Resources
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                            case 'asses':
                                return (
                                    <Assessment
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                            default:
                                return (
                                    <ParentDtls
                                        setLoader={setLoader}
                                        setOpacity={setOpacity}
                                        schoolId={schoolId}
                                        acdYrId={acdYrId}
                                        studentId={studentId}
                                        clsId={clsId}
                                    />);
                        }
                    })()}
                </div>
            </div>
        </div>
    )
}

export default HpcParentAssessment;